import React from 'react';
import { Container } from '@mui/material';
import SaidaAdicionarProduto from '../components/saida/SaidaAdicionarProduto';

const SaidaAdicionarProdutos: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <SaidaAdicionarProduto />
    </Container>
  );
};

export default SaidaAdicionarProdutos;
